import React from 'react';
import {
    Card, CardHeader, CardBody, CardFooter,
    CardLink, CardText,
    Modal, ModalBody, ModalFooter,
    Button
} from 'reactstrap';

import FileDownload from "components/Varios/FileDownload.js";

export default class CardInformacionAcademica extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
        };
    }

    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen,
        });
    };

    onClick = change => {
        this.setState(
            {
                isOpen: !this.state.isOpen,
            },
            (() => { this.props.eventDelete() })
        );
    };

    parseDate(date) {
        if (date) {
            date = new Date(date)
            return date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()
        }
        return null
    }

    render() {

        return (
            <div className="col-md-4 col-xs-4 pr-sm-0" style={{ paddingBottom: "15px" }}>
                <Card>
                    <CardHeader>{this.props.strNivelEstudio}</CardHeader>
                    <CardBody>
                        <CardText>
                            <b>{this.props.institucion}</b>
                            <br />
                            <br />
                            {
                                this.props.tituloobtenido ?
                                    <>
                                        <span className="spanCard">NOMBRE DEL TÍTULO: </span> {this.props.tituloobtenido}
                                        <br />
                                    </>
                                    :
                                    null
                            }
                            <span className="spanCard">PAÍS: </span> {this.props.strNombrePais}
                            <br />
                            <span className="spanCard">FECHA GRADUACIÓN: </span> {this.parseDate(this.props.fechagraduacion)}
                            {
                                ['13', '3', '15'].includes(String((this.props.nivel ? this.props.nivel.trim() : null))) ?
                                <>
                                        <br />
                                        <span className="spanCard">REG. SENESCYT Nº: </span> {this.props.codsenescyt}
                                    <br />
                                        <span className="spanCard">FECHA REGISTRO SENESCYT: </span> {this.parseDate(this.props.fechasenescyt)}
                                        <br />
                                        <br />
                                        <span style={{ color: "#B2B2B2", margin: "0px", display: "inline", fontSize: "10px" }}>CINE </span>
                                    {this.props.strareacampoamplio}
                                    <br />
                                        <span style={{ color: "#B2B2B2", margin: "0px", display: "inline", fontSize: "10px" }}>FRASCATI </span>
                                        {this.props.strareafrascati}
                                    <br />
                                </>
                                    : null
                            }
                        </CardText>
                    </CardBody>
                    <CardFooter className="text-muted">
                        <div style={{ float: "left" }}>
                            {this.props.number}
                        </div>
                        <div style={{ float: "right" }}>
                            <FileDownload files={this.props.evidencias} card={true} icon="download" />
                            <CardLink onClick={this.props.eventEdit} href="#"><i className="fas fa-edit" aria-hidden="true"></i></CardLink>
                            <CardLink onClick={this.toggle} href="#"><i className="fas fa-trash-alt" aria-hidden="true"></i></CardLink>
                        </div>
                    </CardFooter>
                </Card>
                <Modal isOpen={this.state.isOpen} fade={false} toggle={this.toggle} >

                    <ModalBody>
                        ¿Está seguro que desea eliminar el registro?
                        </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={change => this.onClick(change)}>Aceptar</Button>{' '}
                        <Button color="primary" onClick={this.toggle}>Cancelar</Button>
                    </ModalFooter>

                </Modal>
            </div>
        )

    }
}